<template>
  <el-dialog
    class="dialog"
    title="核验意见记录"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @open="fun_Open"
    width="50%"
  >
    <div class="tab">
      <div
        class="tabItem"
        :class="tabActive === '1' ? 'active' : ''"
        @click="fun_GetTabActive('1')"
      >
        核验记录
      </div>
      <div
        class="tabItem"
        :class="tabActive === '2' ? 'active' : ''"
        @click="fun_GetTabActive('2')"
      >
        当前核验节点
      </div>
    </div>
    <Co-list
      ref="list"
      labelWidth="105px"
      :loading="auditLoading"
      :selection="false"
      :form="form"
      :formSearchList="formSearchList"
      :tableColumns="auditTableColumns"
      :tableData="auditTableData"
      :reqPageData="auditReqPageData"
      :total="auditTotal"
      @fun_Search="fun_Search"
      @fun_Reset="fun_Reset"
      @fun_LimitChange="fun_LimitChanges"
      @fun_PageChange="fun_PageChanges"
    >
      <div slot="downFile" slot-scope="data">
        <el-button
          type="text"
          @click="fun_Download(data.data.auditFile)"
          v-if="data.data.auditFile"
          >下载</el-button
        >
      </div>
    </Co-list>
  </el-dialog>
</template>

<script>
// 引入api
import { fun_Download, fun_PostAction } from "@/api";
//引入下载方法
import { fun_DownloadFile } from "@/utils/validate.js";
export default {
  data() {
    return {
      // 切换标识
      tabActive: "1",
      // 关联主键
      recordNumber: null,
      // 弹窗状态
      dialogVisible: false,
      // 弹窗列表状态
      auditLoading: false,
      // 查询表单字段
      form: {
        auditPerson: null, // 核验人员
        auditRemark: null // 核验意见
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "核验人员：",
          value: "auditPerson",
          placeholder: "请输入"
        },
        {
          type: "input",
          label: "核验意见：",
          value: "auditRemark",
          placeholder: "请输入"
        }
      ],
      // 弹窗表格配置
      auditTableColumns: [
        {
          label: "核验人员",
          prop: "auditPerson"
        },
        {
          label: "核验级别",
          prop: "auditLevel"
        },
        {
          label: "核验意见",
          prop: "auditRemark"
        },
        {
          label: "核验时间",
          prop: "insertDate"
        }
      ],
      // 弹窗表格数据
      auditTableData: [],
      // 弹窗表格分页
      auditReqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      auditTotal: 1 // 总条数
    };
  },
  methods: {
    /**
     * 打开弹窗
     */
    fun_Open() {
      this.tabActive = "1";
      // 判断点击的name
      if (this.tabActive === "1") {
        // 核验记录
        // 获取核验步骤
        this.fun_History();
      } else if (this.tabActive === "2") {
        // 当前核验节点
        // 获取核验历史
        this.fun_History();
      }
    },
    /**
     * 切换方法
     */
    fun_GetTabActive(val) {
      // 判断点击的为当前 不执行
      if (this.tabActive === val) return false;
      // 赋值
      this.tabActive = val;
      // 判断点击的name
      if (val === "1") {
        // 核验记录
        // 查询字段
        this.form = {
          auditPerson: null, // 核验人员
          auditRemark: null // 核验意见
        };
        // 查询字段
        this.formSearchList = [
          {
            type: "input",
            label: "核验人员：",
            value: "auditPerson",
            placeholder: "请输入"
          },
          {
            type: "input",
            label: "核验意见：",
            value: "auditRemark",
            placeholder: "请输入"
          }
        ];
        // 显示内容
        this.auditTableColumns = [
          {
            label: "核验人员",
            prop: "auditPerson"
          },
          {
            label: "核验级别",
            prop: "auditLevel"
          },
          {
            label: "核验意见",
            prop: "auditRemark"
          },
          {
            label: "核验时间",
            prop: "insertDate"
          }
        ];
        // 获取核验历史
        this.fun_History();
      } else if (val === "2") {
        // 当前核验节点
        // 查询字段
        this.form = {
          auditPerson: null, // 核验人员
          auditLevel: null // 核验级别
        };
        // 查询字段
        this.formSearchList = [
          {
            type: "input",
            label: "核验人员：",
            value: "auditPerson",
            placeholder: "请输入"
          },
          {
            type: "input",
            label: "核验级别：",
            value: "auditLevel",
            placeholder: "请输入"
          }
        ];
        // 显示内容
        this.auditTableColumns = [
          {
            label: "核验人员",
            prop: "auditPerson"
          },
          {
            label: "监管单位",
            prop: "departmentName"
          },
          {
            label: "核验级别",
            prop: "auditLevel"
          },
          {
            label: "核验节点名称",
            prop: "processNode"
          }
        ];
        // 获取核验历史
        this.fun_History();
      }
    },
    /**
     * 获取核验历史
     */
    async fun_History() {
      // 打开loading
      this.auditLoading = true;
      let res = await fun_PostAction(
        "/auditLog/page?recordNumber=" + this.recordNumber,
        this.auditReqPageData
      );
      // 解构res.data
      const { result, data, msg } = res.data;
      if (result) {
        this.auditTotal = data.total;
        // 回显详情
        this.auditTableData = data.records;
        // 关闭loading
        this.auditLoading = false;
      } else {
        // 提示请求失败消息
        this.$message.error(msg);
        // 关闭loading
        this.auditLoading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_History();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_History();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChanges(e) {
      // 获取每页显示条数
      this.auditReqPageData.size = e;
      // 获取一览表格数据
      this.fun_History();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChanges(e) {
      // 获取当前页码
      this.auditReqPageData.current = e;
      // 获取一览表格数据
      this.fun_History();
    },
    /**
     * 下载
     * @params e 行数据
     * @author 滕威
     */
    fun_Download(e) {
      // 提示
      if (e) {
        // 下载文件
        fun_Download("/api/download?filePath=" + e).then(res => {
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          // 调用下载文件公共方法
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
        });
      } else {
        this.$message.error("文件不存在！");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog {
  .el-dialog__body {
    .tab {
      border-bottom: 1px solid #e9e9e9;
      line-height: 32px;
      margin-bottom: 20px;
      display: flex;
      padding: 0 10px;
      .tabItem {
        color: #333333;
        padding: 0 20px;
        text-align: center;
        font-size: 16px;
        cursor: pointer;
      }
      .active {
        color: #1890ff;
        border-bottom: 2px solid #1890ff;
      }
    }
  }
}
</style>
